import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { OrderServiceService } from 'src/app/admin/services/orders/order-service.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-list-report-query-not-replied',
    templateUrl: './list-report-query-not-replied.component.html',
    styleUrls: ['./list-report-query-not-replied.component.scss'],
    standalone: false
})
export class ListReportQueryNotRepliedComponent implements OnInit {

  constructor(
    private order: OrderServiceService,
    private spinner: NgxSpinnerService,
    private userdata: UserdataService,
    private modalService: NgbModal,
    private toast: ToastrService
  ) { }
  title = 'angular-datatables';

  queryList = [];
  id: any = '';
  temp: any = [];
  getQueryData: any = [];
  ColumnMode = ColumnMode;
  token: any = [];

  @ViewChild(DatatableComponent) myFilterTable: DatatableComponent | any;

  ngOnInit() {
    this.getQueryOrderList()
    this.queryList = this.getQueryData;
  }

  /* ***********
  list All Orders
  *********** */

  getQueryOrderList() {
    this.spinner.show()
    this.order.queriesNotRepliedAfterAday({}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.queryList = res.result;
        //console.log(this.queryList)
        this.temp = this.queryList;
        this.getQueryData = this.queryList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  /**
 * Update filter
 */
  updateFilter(event: any) {
    //console.log(this.temp)
    const val = event.target.value.toLowerCase();

    const temp = this.temp.filter(function (d: any) {
      return d.customerId?.name.toLowerCase().indexOf(val) !== -1 ||
        d.oquestionId.toString().indexOf(val) !== -1 ||
        d.astroId?.displayname.toLowerCase().indexOf(val) !== -1 || !val
    });

    // update the rows
    this.queryList = temp;
    // Whenever the filter changes, always go back to the first page
    this.myFilterTable.offset = 0;
  }

  /** Answer Query */
  closeResult = '';
  singleData:any = ''
  open(content:any,data:any) {
    this.singleData = data
    this.formGroup.patchValue({ astro_answer: '' })
    this.characterCount = 0
    this.modalService.open(content, { size: 'xl' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  characterCount = 0
  countError = true
  countCharacters(event: any) {
    this.characterCount = event.target.value.replace(/\s/g, "").length
    if (this.characterCount >= 600) {
      this.countError = false
    }
  }

  queryAnswer() {
    var msg = (this.formGroup.get('astro_answer')?.value).trim()
    var count = (msg.match(/\d/g) || []).length
    var emailsArray = msg.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
    if (count == 10 || (emailsArray != null && emailsArray.length)) {
      Swal.fire('Invalid Reply', "This message cannot be sent as our policy doesn't allows to share number or email", 'error')
      return;
    }
    this.formGroup.patchValue({ astro_answer: msg })
    this.spinner.show()
    this.formGroup.patchValue({ questionId: this.singleData?._id })
    this.order.answerQueryAdmin(this.formGroup.value).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.toast.success(res.message, 'Success')
        this.modalService.dismissAll()
        this.getQueryOrderList()
      }, err => {
        this.spinner.hide()
        this.toast.error(err.error.message, 'Error')
      }
    )
  }

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    questionId: new UntypedFormControl(''),
    astro_answer: new UntypedFormControl('', [Validators.required]),
  });
}


